class LootRoller{
    constructor ($http, $scope) {
        this.$http = $http;
        this.$scope = $scope;
        this.items = [];
        this.rarity = 0;
    }

    roll()
    {
        this.$http(
            {
                url: "/api/loot/roll",
                method: "post",
                data: $.param({
                    rarity: this.rarity
                }),
                headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}
            }
        ).then((resp) => {
            console.log(resp);
            this.items = resp.data;
        }, (err) => {
            console.log(err);
        });
    }

    save()
    {
        this.$http({
            url: "/api/loot/save",
            method: "post",
            data: $.param({
                items: JSON.stringify(this.items),
                name: this.lootname,
                rarity: this.rarity,
                saveid: this.saveid
            }),
            headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}
        })
            .then((resp)=>{
                console.log(resp);
                this.saveid = resp.data.saveid;
                this.rarity = resp.data.rarity;
                this.lootname = resp.data.name;
                this.items = resp.data.items;
                this.lootid = resp.data.lootid;
            }, (err) => {
                console.log(err);
            });
    }

}

LootRoller.$inject = ['$http', '$scope'];

export {LootRoller};